<template>
  <main class="formig-page overflow-x-hidden">
    <div
      v-if="formErrorOpen"
      class="fixed inset-0 z-[120] bg-black/50 flex items-center justify-center px-4"
    >
      <div
        class="w-full max-w-[560px] rounded-2xl bg-white p-5 sm:p-6 relative"
      >
        <button
          type="button"
          class="absolute top-3 right-3 text-[#0D2651] hover:opacity-80 transition-opacity"
          @click="formErrorOpen = false"
          aria-label="Fermer la popup des erreurs"
        >
          <i class="fa-solid fa-xmark text-xl"></i>
        </button>
        <h3
          class="font-barlow-condensed font-bold uppercase text-[#0D2651] text-[28px] sm:text-[32px] leading-tight text-center mb-4"
        >
          Le formulaire contient des erreurs
        </h3>
        <ul
          class="list-disc pl-6 pr-2 space-y-2 text-[#0D2651] text-base sm:text-lg"
        >
          <li
            v-for="(message, index) in formErrorMessages"
            :key="`${message}-${index}`"
          >
            {{ message }}
          </li>
        </ul>
        <div class="mt-6 text-center">
          <button
            type="button"
            class="inline-flex items-center justify-center rounded-full bg-[#0D2651] px-6 py-2.5 text-white font-barlow-condensed font-bold uppercase text-lg leading-none hover:opacity-90 transition-opacity"
            @click="formErrorOpen = false"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="help"
      class="w-full h-full bg-black/50 z-50 fixed inset-0 flex justify-center items-center"
    >
      <div class="bg-white text-[#0067A4] p-4 rounded-lg relative">
        <i
          class="absolute right-2 top-2 fa-solid fa-xmark cursor-pointer"
          @click="help = false"
        ></i>
        <p class="text-lg text-center pt-3">
          Le numéro à 13 chiffres démarre<br />
          par 30190 pour les boîtes de thon et<br />
          37602 pour les paquets de saumon,<br />truite ou crevettes.
        </p>
      </div>
    </div>

    <div
      class="fixed inset-0 h-full w-full z-[100] pointer-events-none"
      v-if="vague"
    >
      <img
        v-if="vague"
        :key="'vague-desk-' + vagueReplayKey"
        :src="'/vague.gif?r=' + vagueReplayKey"
        class="w-full h-full object-cover hidden sm:block"
        alt=""
      />
      <img
        :key="'vague-mob-' + vagueReplayKey"
        :src="'/vague-mobile.gif?r=' + vagueReplayKey"
        class="w-full h-full object-cover sm:hidden"
        alt=""
      />
    </div>
    <audio
      ref="audioPlayer"
      src="/audiomass-output2.mp3"
      preload="auto"
    ></audio>

    <!-- Même gabarit flex que /form (form-section-1) pour éviter min-width:auto du builder -->
    <section
      class="formig-section formig-section-main relative z-[5] w-full min-w-0"
    >
      <div
        class="mx-auto relative w-full min-w-0 max-w-[1440px] flex flex-col min-h-0"
      >
        <div
          class="flex-1 min-h-0 min-w-0 flex items-start justify-center w-full pt-24 sm:pt-20 lg:pt-8"
        >
          <div
            class="max-w-6xl mx-auto w-full min-w-0 flex flex-wrap lg:flex-nowrap justify-between items-start py-10 sm:py-14 lg:py-20 px-4 sm:px-6 lg:gap-16"
          >
            <!-- Colonne gauche : titres + lots -->
            <div
              class="w-full min-w-0 max-w-full lg:max-w-[506px] text-center lg:text-left mb-10 lg:mb-0 lg:pt-8 xl:pt-16"
            >
              <h1 class="formig-title mb-4 max-w-full break-words">
                <span class="formig-title-bleu">tentez votre chance</span
                ><span class="formig-title-blanc"> pour gagner </span
                ><span class="formig-title-beige"
                  >un des kits de dégustation collectors !</span
                >
              </h1>
              <p
                class="font-barlow-condensed font-bold text-white text-xl sm:text-2xl lg:text-[24px] lg:leading-[28px] lg:max-w-[350px] max-w-full break-words"
              >
                Après avoir rempli ce formulaire, vous recevrez la liste des
                étapes à suivre.
              </p>
              <div class="w-full min-w-0 max-w-full overflow-x-hidden mt-8">
                <img
                  src="@/assets/images/forms/lots.svg"
                  alt="Lots à gagner"
                  class="block w-full max-w-full sm:max-w-[460px] h-auto mx-auto lg:mx-0"
                />
              </div>
            </div>

            <!-- Colonne droite : formulaire -->
            <div
              ref="formCard"
              class="formig-card box-border w-full min-w-0 max-w-[588px] mx-auto lg:mx-0"
            >
              <div ref="formWrap" class="min-w-0 w-full">
                <Form
                  class="formig-form w-full max-w-full mx-auto"
                  id="createForm"
                  form_id="6904b53e310c505cd7f8a35a"
                  server="https://api-gabarit.promo.dev"
                  v-on:results="getResult"
                  v-on:form_submit_loading="onLoading"
                  :hideError="hiderror"
                  @on_error="showErrorForm"
                  :relay="relay"
                />
              </div>
              <p class="mention2 mt-4 text-[#0D2651] text-sm text-center">
                *Champs obligatoires
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { setGameResult } from "@/gameResult";
import router from "@/router";

export default {
  name: "Form2View",
  data() {
    return {
      hiderror: true,
      loading: false,
      error: false,
      formErrorOpen: false,
      formErrorMessages: [],
      nativeAlert: null,
      relay: null,
      vague: false,
      /** Incrémenté à chaque vague : relance l’animation GIF (évite le cache navigateur). */
      vagueReplayKey: 0,
      help: false,
    };
  },
  created() {
    this._vagueNavTimer = null;
    this._vagueNavGen = 0;
  },
  mounted() {
    this.nativeAlert = window.alert;
    window.alert = (message) => {
      const msg = String(message || "");
      if (
        msg.includes(
          "Veuillez vérifier les erreurs restantes dans le formulaire",
        ) ||
        msg.includes("Corrigez les erreurs")
      ) {
        this.formErrorMessages = [msg];
        this.formErrorOpen = true;
        this.loading = false;
        this.error = true;
        return;
      }
      this.nativeAlert?.(message);
    };

    this.vague = false;
    this.$nextTick(() => {
      setTimeout(() => {
        const element = document.querySelector("#infosbull");
        if (element) {
          element.addEventListener("click", () => {
            this.help = true;
          });
        }
      }, 1000);
    });
    this.$nextTick(() => {
      setTimeout(() => {
        this.injectNoticeNextToCode();
        this.styleReceiptNotice();
      }, 800);
    });

  },
  beforeDestroy() {
    if (this._vagueNavTimer != null) {
      clearTimeout(this._vagueNavTimer);
      this._vagueNavTimer = null;
    }
    if (this.nativeAlert) {
      window.alert = this.nativeAlert;
    }
    if (this.$refs.audioPlayer) {
      this.$refs.audioPlayer.pause();
      this.$refs.audioPlayer.currentTime = 0;
    }
  },
  beforeUnmount() {
    if (this._vagueNavTimer != null) {
      clearTimeout(this._vagueNavTimer);
      this._vagueNavTimer = null;
    }
    if (this.nativeAlert) {
      window.alert = this.nativeAlert;
    }
  },
  methods: {
    styleReceiptNotice() {
      const card = this.$refs.formCard;
      if (!card) return;
      const receiptInfo = card.querySelector(".input_wrapper_receipt .info");
      if (!receiptInfo) return;
      const html = receiptInfo.innerHTML;
      const parts = html.split("<br>");
      if (parts.length >= 2) {
        receiptInfo.innerHTML =
          parts[0] +
          '<br><span class="receipt-conservez">' +
          parts.slice(1).join("<br>") +
          "</span>";
      }
    },
    injectNoticeNextToCode() {
      const card = this.$refs.formCard;
      if (!card) return;
      const eanWrapper = card.querySelector(".input_wrapper_ean");
      const receiptWrapper = card.querySelector(".input_wrapper_receipt");
      if (!eanWrapper) return;
      const row = document.createElement("div");
      row.className = "formig-code-row";
      eanWrapper.parentNode.insertBefore(row, eanWrapper);
      row.appendChild(eanWrapper);
      if (receiptWrapper) {
        row.appendChild(receiptWrapper);
      }
    },
    onLoading() {
      this.loading = true;
    },
    showErrorForm(event) {
      const rawError = event?.error;
      const fallback = [
        "Une erreur est survenue. Veuillez vérifier les champs du formulaire.",
      ];
      const messages = Array.isArray(rawError?.message)
        ? rawError.message
        : typeof rawError?.message === "string"
        ? rawError.message.split("\n").filter(Boolean)
        : Array.isArray(rawError?.errors)
        ? rawError.errors
            .map((item) =>
              typeof item === "string"
                ? item
                : item?.message || item?.error || null,
            )
            .filter(Boolean)
        : fallback;
      this.formErrorMessages = messages.length ? messages : fallback;
      this.formErrorOpen = true;
      this.loading = false;
      this.error = true;
    },
    getResult(result) {
      if (result && result.status) {
        if (this._vagueNavTimer != null) {
          clearTimeout(this._vagueNavTimer);
          this._vagueNavTimer = null;
        }
        this._vagueNavGen += 1;
        const gen = this._vagueNavGen;

        this.vagueReplayKey += 1;
        setGameResult(result, "formig");
        this.vague = true;
        void this.$refs.audioPlayer?.play?.().catch(() => {});

        this._vagueNavTimer = setTimeout(() => {
          this._vagueNavTimer = null;
          if (gen !== this._vagueNavGen) return;

          this.vague = false;
          const status = (result.status || "").toString().toUpperCase();
          const lot = (result.lot || "").toString().toLowerCase();

          if (
            status === "GAGNE" &&
            (lot === "kit-apero" || lot === "kit-salade")
          ) {
            router.push({ path: "/status/" + result._id + "/" + result.uid });
          } else if (status === "PERD") {
            router.push({ name: "perdu" });
          } else {
            alert("Résultat inattendu, veuillez réessayer plus tard.");
          }
        }, 1700);
      } else {
        alert("Une erreur est survenue, veuillez réessayer plus tard.");
      }
    },
  },
};
</script>

<style scoped>
.formig-page {
  background-color: #0d2651;
  background-image: url("@/assets/images/fond-perdu.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
}

.formig-section {
  position: relative;
  z-index: 10;
}

/* Comme .form-page + .form-section-1 sur /form */
.formig-page,
.formig-section-main {
  width: 100%;
  max-width: 100vw;
  overflow-x: clip;
}

/* Même logique que .form-section-1 sur /form : tous les wrappers du builder */
.formig-page :deep(#createForm) {
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.formig-page :deep(#createForm .form-step) {
  min-width: 0;
  width: 100%;
}
.formig-page :deep(#createForm .input_wrapper),
.formig-page :deep(#createForm [class*="input_wrapper_"]) {
  min-width: 0 !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
/* Ne pas forcer la largeur sur checkbox / file / boutons (sinon layout cassé) */
.formig-page
  :deep(
    #createForm
      input:not([type="checkbox"]):not([type="radio"]):not([type="file"]):not(
        [type="hidden"]
      ):not([type="submit"]):not([type="button"])
  ),
.formig-page :deep(#createForm select),
.formig-page :deep(#createForm textarea) {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.formig-page :deep(#createForm .multiselect),
.formig-page :deep(#createForm .multiselect__tags) {
  min-width: 0 !important;
  max-width: 100%;
  box-sizing: border-box;
}

/* CTA / règlement : même portée que le reste du builder (comme /form) */
.formig-page :deep(.builder-buttons) {
  display: flex;
  justify-content: center !important;
  width: 100%;
  margin-bottom: 1.5rem;
}
.formig-page :deep(#next_button) {
  width: 344px;
  max-width: 100%;
  height: 58px;
  padding: 0 !important;
  margin: 0;
  border: none !important;
  border-radius: 29px;
  background: url("@/assets/images/forms/CTA-form2.svg") center / contain
    no-repeat !important;
  background-color: #0d2651 !important;
  color: transparent !important;
  font-size: 0;
  text-indent: -9999px;
  cursor: pointer;
  overflow: hidden;
  transition: none !important;
}
.formig-page :deep(#next_button:hover) {
  background: url("@/assets/images/forms/CTA-form2.svg") center / contain
    no-repeat !important;
  background-color: #0d2651 !important;
  color: transparent !important;
  border: none !important;
}
.formig-page :deep(#opt_in_rules_element label) {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: nowrap;
  gap: 0.25rem;
}
.formig-page :deep(#opt_in_rules_element label > div) {
  display: inline;
}
.formig-page :deep(#opt_in_rules_element .required-star) {
  white-space: nowrap;
  line-height: 1;
}

.formig-card {
  background: #fff;
  border-radius: 35px;
  padding: 2rem 1.5rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

/* DES - Titre 3 - MAJ : 40px, 700, 48px line-height, uppercase */
.formig-title {
  font-family: "Barlow Condensed", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  overflow-wrap: anywhere;
}
@media (min-width: 1024px) {
  .formig-title {
    font-size: 40px;
    line-height: 48px;
  }
}
.formig-title-bleu {
  color: #2490be;
}
.formig-title-blanc {
  color: #fff;
}
.formig-title-beige {
  color: #feefc7;
}

/* Ligne Code + Upload côte à côte (injecté en JS) */
.formig-card :deep(.formig-code-row) {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: start;
  width: 100%;
  min-width: 0;
  flex: 0 0 100%;
}
@media (min-width: 640px) {
  .formig-card :deep(.formig-code-row) {
    grid-template-columns: 1fr 1fr;
    align-items: start;
  }
}
.formig-card :deep(.formig-code-row > .input_wrapper_ean),
.formig-card :deep(.formig-code-row > .input_wrapper_receipt) {
  min-width: 0;
  width: 100% !important;
  max-width: none;
}
.formig-card :deep(.formig-code-row > .input_wrapper_ean input),
.formig-card :deep(.formig-code-row > .input_wrapper_receipt input) {
  width: 100%;
  box-sizing: border-box;
}

/* Label EAN : tout (texte + icône info + étoile) doit tenir sur une seule
   ligne dans la colonne EAN (grille 2 colonnes de .formig-code-row). On
   force le non-wrap sur le label et on réduit légèrement la taille de la
   police aux tailles intermédiaires pour éviter tout débordement. */
.formig-card :deep(.input_wrapper_ean label) {
  display: block;
  white-space: nowrap;
}
.formig-card :deep(.input_wrapper_ean label img#infosbull) {
  display: inline;
  vertical-align: middle;
}
.formig-card :deep(.input_wrapper_ean label .required-star) {
  display: inline;
  white-space: nowrap;
}
@media (min-width: 640px) and (max-width: 1199px) {
  .formig-card :deep(.input_wrapper_ean label) {
    font-size: 14px;
  }
}

/* Bouton Télécharger — remonté au niveau de l'input gauche */
.formig-card :deep(.upload-btn) {
  background-color: #2490be !important;
  color: #fff !important;
  margin-top: 0 !important;
  margin-bottom: 0.25rem !important;
}
.formig-card :deep(.upload-btn:hover) {
  background-color: #1a7ba3 !important;
}
.formig-card :deep(.upload-btn-wrapper) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.formig-card :deep(.input_wrapper_receipt .info) {
  margin-top: 0.5rem !important;
}
/* Texte "Conservez votre preuve..." en bleu clair + gras */
.formig-card :deep(.receipt-conservez) {
  color: #2490be;
  font-weight: 700;
}

/* Bloc bleu à droite du champ code */
.formig-notice {
  background: #2490be;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  max-width: 280px;
}
@media (min-width: 1024px) {
  .formig-notice {
    max-width: 256px;
  }
}
.formig-notice-standalone {
  display: none;
}
.formig-card :deep(.formig-code-row .formig-notice) {
  display: block;
  margin-top: 0.75rem;
  grid-column: 1 / -1;
}
.formig-notice-text {
  font-family: "Barlow Condensed", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: #fff;
  margin: 0;
  text-align: left;
}

.formig-form {
  width: 100%;
}
</style>
